import initWxShare from "@/utils/initWxShare"
import getRandomStr from "@/utils/getRandomStr"
import setDocumentTitle from "@/utils/setDocumentTitle"
import resolveComment from "@/utils/resolveComment"
import { getActivityDetail, getMyMessageList, handleInteractionprasie, getSpecialArticle, getTemplate, getAreaStatistics } from "../../server/interfaces"
import store from "../index"

const UPDATE_MSG_DELAY = 3000
const MSG_COLOR_Class_MAP = {
  bg_gray: "bg_orange",
  bg_orange: "bg_gray"
}
const PANEL_TITLE_BG = require("../../assets/images/tag.png")
const MSG_MAX_LENGTH = 7

export default {
  namespaced: true,
  state: {
    activityId: "",
    shareInfo: {
      title: " ",
      desc: `“南方+”创造更多价值！`,
      link: window.location.href,
      imgUrl: "https://static.nfapp.southcn.com/app/nanfang_logo.png"
    },
    newMessageList: [],
    currentMessageList: [],
    updateMsgTimer: null,
    navList: [],
    messageBoardOutViewPort: false,
    activityDetail: {
      heroActivityApiVo: {},
      heroColumnVOList: [],
      messageVOList: [],
      activityRefVOList: [],
      columnId: ""
    },
    areaDistributionResult: {},
    interactionBtns: [],
    maxCount: 0,
    myMessageList: [],
    templateList: [],
    panelTitleBg: ""
  },
  getters: {
    templateList: state => state.templateList,
    currentMessageList: state => state.currentMessageList,
    navList: state => state.navList,
    activityDetail: state => state.activityDetail,
    heroActivityApiVo: state => state.activityDetail.heroActivityApiVo,
    heroColumnVOList: state => state.activityDetail.heroColumnVOList,
    messageVOList: state => state.activityDetail.messageVOList,
    backgroundColor: state => `linear-gradient(-180deg, ${state.activityDetail.heroActivityApiVo.backTopColor} 0%, ${state.activityDetail.heroActivityApiVo.backBottomColor} 96%)`,
    interactionBtns: state => state.interactionBtns,
    showMessageBord: state => {
      const activityMainModule = state.activityDetail.heroColumnVOList.find(item => item.isFirst)
      if (activityMainModule) {
        return activityMainModule.messageSwitch == 1
      } else {
        return false
      }
    },
    articlePanelModules: state => state.navList.slice(1),
    myMessageList: state => state.myMessageList,
    fontColor: state => state.activityDetail.heroActivityApiVo.mainColor,
    activityList: state => {
      const url = `${window.location.origin}${window.location.pathname}`
      return state.activityDetail.activityRefVOList.map(item => ({
        ...item,
        activityName: item.buttonName,
        url: `${url}?id=${item.refId}`
      }))
    },
    involvedMember: state => state.activityDetail.heroActivityApiVo.bottomText,
    shareBgColor: state => `linear-gradient(-180deg, ${state.activityDetail.heroActivityApiVo.posterBackTop} 0%, ${state.activityDetail.heroActivityApiVo.posterBackBottom} 96%)`,
    shareTitle: state => state.activityDetail.heroActivityApiVo.shareTitle,
    shareText: state => state.activityDetail.heroActivityApiVo.shareText,
    posterImage: state => `data:image/jpg;base64,${state.activityDetail.heroActivityApiVo.posterImage}`,
    actiName: state => state.activityDetail.heroActivityApiVo.actiName,
    posterClockText: state => state.activityDetail.heroActivityApiVo.posterClockText,
    maxCount: state => {
      const interactionBtns = state.interactionBtns.slice(0)
      const maxCountItem = interactionBtns.sort((a, b) => b.count - a.count)[0]
      return maxCountItem ? maxCountItem.count : 0
    },
    btnColorMsg: state => `linear-gradient(-179deg, ${state.activityDetail.heroActivityApiVo.msgTopColor} 0%, ${state.activityDetail.heroActivityApiVo.msgBottonColor} 100%)`,
    btnColorShare: state => `linear-gradient(-179deg, ${state.activityDetail.heroActivityApiVo.sharePosterTop} 0%, ${state.activityDetail.heroActivityApiVo.sharePosterBottom} 100%)`,
    switchActivityBtnText: state => state.activityDetail.heroActivityApiVo.switchButton,
    downloadBg: state => state.activityDetail.heroActivityApiVo.downloadImage,
    messageBoardTitle: state => {
      const activityMainModule = state.activityDetail.heroColumnVOList.find(item => item.isFirst)
      if (activityMainModule) {
        return activityMainModule.columnName
      } else {
        return "留言板"
      }
    },
    panelTitleBg: state => {
      return state.activityDetail.heroActivityApiVo.columnIcon || PANEL_TITLE_BG
    },
    distributionTitlePic: state => state.activityDetail.heroActivityApiVo.distributionTitlePic,
    areaDistributionResult: state => state.areaDistributionResult,
    areaDataDistribution: state => state.activityDetail.heroActivityApiVo.areaDataDistribution,
    activityId: state => state.activityId
  },
  mutations: {
    setShareInfo(state, shareInfo) {
      Object.assign(state.shareInfo, shareInfo)
    },
    setActivityId(state, activityId) {
      state.activityId = activityId
    },
    setMessageList(state, messageList) {
      const newMessageList = messageList
        .map((item, index) => ({
          key: getRandomStr(),
          ...item,
          colorClass: index % 2 === 0 ? "bg_gray" : "bg_orange"
        }))
        .reverse()
      state.currentMessageList = newMessageList.splice(0, MSG_MAX_LENGTH)
      state.newMessageList = newMessageList
    },
    updateNewMesageList(state, messageList) {
      messageList = messageList.map(item => {
        return {
          ...item,
          key: getRandomStr()
        }
      })
      state.newMessageList.push(...messageList)
    },
    disableUpdateMessageList(state) {
      if (state.updateMsgTimer) {
        window.clearInterval(state.updateMsgTimer)
        state.updateMsgTimer = null
        state.messageBoardOutViewPort = true
      }
    },
    setMessageBoardOutViewPort(state, status) {
      state.messageBoardOutViewPort = status
    },
    updateMessageList(state) {
      if (state.updateMsgTimer) return
      if (state.newMessageList.length > 0) {
        state.updateMsgTimer = window.setInterval(() => {
          const newMessage = state.newMessageList.splice(0, 1)[0]
          const fistCurrentMsgColorClass = state.currentMessageList[0] ? state.currentMessageList[0].colorClass : "bg_orange"
          const newMsgColorClass = MSG_COLOR_Class_MAP[fistCurrentMsgColorClass]
          newMessage.colorClass = newMsgColorClass
          state.currentMessageList.unshift(newMessage)
          if (state.currentMessageList.length > MSG_MAX_LENGTH) {
            const oldMessageItem = state.currentMessageList.pop()
            state.newMessageList.push(oldMessageItem)
          }
          if (state.newMessageList.length < 1) {
            window.clearInterval(state.updateMsgTimer)
            state.updateMsgTimer = null
          }
        }, UPDATE_MSG_DELAY)
      }
    },
    setActivityDetail(state, activityDetail) {
      state.activityDetail = Object.assign(state.activityDetail, activityDetail)
      state.activityDetail.columnId = activityDetail.heroColumnVOList[0].id
      state.panelTitleBg = activityDetail.heroActivityApiVo.columnIcon || PANEL_TITLE_BG
    },
    setAreaDistributionResult(state, areaDistributionResult) {
      state.areaDistributionResult = areaDistributionResult
    },
    initInteractionBtnsDetail(state) {
      const interactionBtnsDetail = state.activityDetail.heroColumnVOList.find(item => item.isFirst)
      const giveFlowerBtnItem = interactionBtnsDetail.firstButtonText
        ? {
            actionType: "giveFlower",
            btnText: interactionBtnsDetail.firstButtonText,
            count: interactionBtnsDetail.firstButtonCount || 0,
            icon: interactionBtnsDetail.firstButtonUrl,
            actionId: 0
          }
        : null
      const bowBtnItem = interactionBtnsDetail.secendButtonText
        ? {
            actionType: "bow",
            btnText: interactionBtnsDetail.secendButtonText,
            count: interactionBtnsDetail.secendButtonCount || 0,
            icon: interactionBtnsDetail.secendButtonUrl,
            actionId: 1
          }
        : null
      state.interactionBtns = [giveFlowerBtnItem, bowBtnItem].filter(item => item)
    },
    initNavList(state, navList) {
      const heroColumnVOList = navList.map(item => {
        return {
          ...item,
          id: item.id,
          targetId: `activityModule_${item.id}`,
          label: item.columnName,
          actionBtnText: item.shareButton,
          titleImg: state.panelTitleBg,
          shareUrl: item.manuscriptUrl
        }
      })
      state.navList = heroColumnVOList.filter(item => item.isFirst || (item.articleList && item.articleList.length > 0))
    },
    setMaxCoount(state) {
      const heroColumnVOList = state.activityDetail.heroColumnVOList
      const interactionItem = heroColumnVOList.find(item => item.isFirst)
      const maxCount = [interactionItem.firstButtonCount, interactionItem.secendButtonCount].sort((a, b) => b - a)[0]
      state.maxCount = maxCount
    },
    setMyMessageList(state, myMessageList) {
      state.myMessageList = myMessageList
    },
    updateMyMessageList(state, messageItem) {
      state.myMessageList.unshift(messageItem)
    },
    setTemplateList(state, templateList) {
      state.templateList = templateList
    },
    updateInteractionCount(state, interactionItem) {
      const actionType = interactionItem.actionType
      const actionIndex = state.interactionBtns.findIndex(item => item.actionType === actionType)
      if (actionIndex > -1) {
        const newsInteractionBtns = state.interactionBtns.slice(0)
        const actionItem = newsInteractionBtns[actionIndex]
        actionItem.count++
        state.interactionBtns = [...newsInteractionBtns]
      }
    }
  },
  actions: {
    async getActivityDetail({ commit, dispatch, state }) {
      const activityId = state.activityId
      if (!activityId) {
        window.console.error("请传入活动id")
        return
      }
      const params = {
        activityId: activityId
      }
      const activityDetail = await getActivityDetail({ params })
      if (activityDetail) {
        commit("setActivityDetail", activityDetail)
        setDocumentTitle(activityDetail.heroActivityApiVo.actiName)
        dispatch("initShareInfo")
        commit("initInteractionBtnsDetail")
        commit("setMaxCoount")
        dispatch("getAreaStatistics")
        dispatch("getMyMessageList")
        dispatch("getTemplateList")
        // 测试代码
        commit("setMessageList", activityDetail.messageVOList)
        // 测试代码结束
        commit("updateMessageList")
        const navList = await getArticleList(state.activityDetail.heroColumnVOList)
        commit("initNavList", navList)
      }
    },
    initWxShare({ rootState }) {
      const isWx = rootState.systemInfo.isWx
      if (!isWx) return
      const shareOptions = { ...rootState.activityInfo.shareInfo }
      initWxShare(shareOptions)
    },
    initNfPluseShare({ rootState }) {
      const isNfPlus = rootState.systemInfo.isNfPlus
      if (!isNfPlus) return
      const shareInfo = rootState.activityInfo.shareInfo
      const nfPlusShareInfo = {
        shareTitle: shareInfo.title,
        shareIcon: shareInfo.imgUrl,
        shareDesc: shareInfo.desc,
        shareUrl: shareInfo.link
      }
      window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
    },
    initShareInfo({ dispatch, commit, state }) {
      const heroActivityApiVo = state.activityDetail.heroActivityApiVo
      const heroColumnVOList = state.activityDetail.heroColumnVOList
      const interactionItem = heroColumnVOList.find(item => item.isFirst)
      let count = [interactionItem.firstButtonCount, interactionItem.secendButtonCount].sort((a, b) => b - a)[0]
      count = count || 0
      const shareInfo = {
        title: resolveComment(heroActivityApiVo.shareTitle, count + 1),
        desc: heroActivityApiVo.shareText,
        link: window.location.href,
        imgUrl: heroActivityApiVo.shareIcon || "https://static.nfapp.southcn.com/app/nanfang_logo.png"
      }
      commit("setShareInfo", shareInfo)
      dispatch("initWxShare")
      dispatch("initNfPluseShare")
    },
    async getAreaStatistics({ commit, state }) {
      const activityId = state.activityId
      if (!activityId) {
        window.console.error("请传入活动id")
        return
      }
      const areaDistributionResult = await getAreaStatistics({ params: { activityId: activityId } })
      if (areaDistributionResult) {
        commit("setAreaDistributionResult", areaDistributionResult)
      }
    },
    async getMyMessageList({ commit, state, rootState }) {
      const columnId = state.activityDetail.columnId
      const hasUserUuid = !!rootState.userInfo.userInfo.userUuid
      if (!hasUserUuid) return
      const params = {
        columnId: columnId
      }
      if (!columnId) {
        return
      }
      const myMessageList = await getMyMessageList({ params })
      window.console.log("myMessageList", myMessageList)
      if (myMessageList && Array.isArray(myMessageList)) {
        commit("setMyMessageList", myMessageList)
        // 更新用户名称
        if (myMessageList[myMessageList.length - 1] && myMessageList[myMessageList.length - 1].userName) {
          window.console.log("更新用户名称", myMessageList[myMessageList.length - 1].userName)
          store.dispatch("userInfo/setUserInfo", { userName: myMessageList[myMessageList.length - 1].userName })
        }
      }
    },
    async getTemplateList({ commit, state }) {
      const columnId = state.activityDetail.columnId
      const params = {
        columnId: columnId
      }
      const templateList = await getTemplate({ params })
      if (templateList && Array.isArray(templateList)) {
        commit("setTemplateList", templateList)
      }
    },
    async handleInteractionprasie({ commit, state }, interactionItem) {
      const params = {
        params: {
          type: interactionItem.actionId,
          columnId: state.activityDetail.columnId
        }
      }
      commit("updateInteractionCount", interactionItem)
      await handleInteractionprasie(params)
    },
    async getMessageList({ commit, state }) {
      // @TODO
      // 获取评论列表
      let count = 1
      let timer = window.setInterval(() => {
        const msgItem = {
          content: "缓存2祭英烈于网上，念英烈于心中。",
          name: "大哥大"
        }
        commit("setMessageList", [msgItem])
        !state.messageBoardOutViewPort && commit("updateMessageList")
        count++
        if (count > 10) {
          window.clearInterval(timer)
          timer = null
        }
      }, 1000)
    },
    enableUpdateMessageList({ commit }) {
      commit("updateMessageList")
    },
    disableUpdateMessageList({ commit }) {
      commit("disableUpdateMessageList")
    },
    updateNewMesageList({ commit, state }, messageList) {
      commit("updateNewMesageList", messageList)
      !state.messageBoardOutViewPort && commit("updateMessageList")
    }
  }
}

function getArticleList(navList) {
  return new Promise(resolve => {
    if (navList) {
      let mouduleCount = navList.filter(item => item.articleId !== undefined && item.linkId !== undefined && item.templateId !== undefined).length
      if (mouduleCount < 1) {
        resolve([])
        return
      }
      let finishRequestModuleCount = 0
      navList.forEach(async item => {
        const { articleId, linkId, templateId } = item
        if (articleId !== undefined && linkId !== undefined && templateId !== undefined) {
          const params = {
            articleId,
            linkId,
            templateId
          }
          const { data, code } = await getSpecialArticle({ params })
          if (code === 200) {
            const articleList = data.list
            item.articleList = articleList
          }
          finishRequestModuleCount++
          if (finishRequestModuleCount === mouduleCount) {
            const newNavList = navList.filter(item => {
              return !(item.articleId !== undefined && item.linkId !== undefined && item.templateId !== undefined && !item.articleList)
            })
            resolve(newNavList)
          }
        }
      })
    }
  })
}
